import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, Link, Typography } from '@material-ui/core';
import { useAuthorizeCheckboxStyles } from './styles';
import { terms, privacyPolicies } from '../../../config/paths';

const AuthorizeCheckbox = ({ ...props }) => {
  const { disabled, idComplement, onCheck } = props;
  const classes = useAuthorizeCheckboxStyles();
  const [checked, setChecked] = useState(false);

  const handleCheck = () => {
    setChecked(!checked);
    onCheck(!checked);
  };

  return (
    <Box className={classes.box}>
      <Checkbox
        className={classes.checkbox}
        onChange={handleCheck}
        checked={checked}
        disabled={disabled}
        id={`authorizeCheckbox${idComplement}`}
        data-cy="authorizeCheckbox"
      />
      <Typography className={classes.text}>
        Acepto los
        <Link target="_blank" href={terms}>
          {' '}
          Términos y Condiciones
        </Link>{' '}
        y las{' '}
        <Link target="_blank" href={privacyPolicies}>
          Políticas de Privacidad
        </Link>
      </Typography>
    </Box>
  );
};

AuthorizeCheckbox.propTypes = {
  disabled: PropTypes.bool,
  idComplement: PropTypes.string,
  onCheck: PropTypes.func,
};

export default AuthorizeCheckbox;
